<template>
    <form @submit="onSubmit" action="/account/forgot-password" method="post" ref="form" class="space-y-8">
        <div class="space-y-6">
            <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <div class="mt-1 relative rounded-md max-w-lg sm:max-w-xs">
                        <input type="hidden" name="_token" :value="csrf">
                        <text-input
                            label="Email"
                            name="email"
                            :validation="v$.email"
                            autocomplete="email"
                            v-model="email"
                        ></text-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="pt-5">
            <div class="flex justify-start">
                <button
                    @click="submit"
                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-md tracking-wider font-medium rounded-md text-white bg-ap-primary hover:bg-ap-primary-darkened focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Continue
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';
import TextInput from '../TextInput.vue';

const { withMessage } = helpers;

export default {
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            email: null,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            errors: {},
        };
    },
    validations() {
        return {
            email: {
                required: withMessage('Email address is required', required),
                email: withMessage('Not a valid email address', email),
            },
        };
    },
    methods: {
        async onSubmit(e) {
            const result = await this.v$.$validate();

            if (!result) {
                e.preventDefault();
                return false;
            }

            return true;
        },
    },
    components: {
        TextInput,
    },
};
</script>
d